<template>
    <v-sheet>
        <p class="page-text--sm grey-9--text mb-4">상태</p>
        <v-select v-model="state" v-bind="{ items }" hide-details prepend-inner-icon="icon-dot" class="v-input--x-small v-input--noborder" @change="(state) => $emit('put', { _id: item._id, state })"> </v-select>
        <div class="mt-n16">
            <i v-if="state == 'ON_GOING'" class="icon icon-dot icon-dot--primary" />
            <i v-else-if="state == 'FINISHED'" class="icon icon-dot icon-dot--green" />
            <i v-else-if="state == 'NO_SHOWN'" class="icon icon-dot icon-dot--yellow" />
            <i v-else-if="state == 'CANCELED'" class="icon icon-dot icon-dot--secondary" />
        </div>
        <!-- <v-card-subtitle class="pa-0"> 상태 </v-card-subtitle>
        <v-card-title class="pa-0"> <v-select v-model="state" v-bind="{ items }" hide-details @change="(state) => $emit('put', { _id: item._id, state })" /> </v-card-title> -->
    </v-sheet>
</template>

<script>
import { RECRUITMENT_STATES } from "@/assets/variables";

const items = Object.values(RECRUITMENT_STATES);

export default {
    props: {
        item: { type: Object, default: () => ({}) },
    },
    data: () => ({
        state: undefined,
        items,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        item() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.state = this.item?.state;
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .v-input__icon {
    width: 6px;
    margin-right: 6px;
    min-width: 0;
}
::v-deep .v-input {
    font-weight: 500;
    font-size: 1.6rem;
}
::v-deep .v-select__selection--comma {
    margin: 0 2px 0 0;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    ::v-deep .v-input__icon {
        width: 8px;
    }
    ::v-deep .v-input {
        font-size: 2rem;
        max-width: 110px;
    }
}
@media (min-width: 1200px) {
}
</style>
